<template>
    <v-form class="m-form" v-bind="$attrs" v-on="$listeners" ref="form">
        <m-block-form-title v-if="'title' in $slots">
            <slot name="title"/>
        </m-block-form-title>

        <v-layout v-if="'content' in $slots" row wrap class="m-form-content">
            <v-flex v-bind="contentProps">
                <slot name="content"/>
            </v-flex>
        </v-layout>

        <template v-if="'content-template' in $slots" >
            <div class="m-form-content-template">
                <slot name="content-template"/>
            </div>
        </template>

        <e-divider-secondary v-if="!disableDivider"/>

        <v-layout v-if="'buttons' in $slots" row wrap class="mt-2 m-form-buttons">
            <v-flex xs12 mx-0>
                <slot name="buttons"/>
            </v-flex>
        </v-layout>

        <template v-if="'buttons-template' in $slots" row wrap>
            <slot name="buttons-template"/>
        </template>
    </v-form>
</template>

<script>
    import MBlockFormTitle from "@modules/blocks/form/m-block-form-title";
    import arrangement from "@mixins/positioning/_arrangement";

    export default {
        name: "m-form",
        inheritAttrs: false,
        mixins: [arrangement],
        components: {MBlockFormTitle},
        props: {
            disableOffset: {
                type: Boolean,
                default: false
            },
            disableDivider: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            contentProps() {
                return !this.disableOffset ? this.getFormPlacing : {xs12:true}
            },
        },
        methods: {
            reset() {
                this.$refs.form.reset()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .m-form {
        padding-top: 30px;
        padding-bottom: 48px;
        &-content, &-content-template{
            margin-top: 30px;
            margin-bottom: 20px;
            @include media(md) {
                margin-top: 20px;
                margin-bottom: 15px;
            }
            @include media(sm) {
                margin-bottom: 10px
            }
        }

        @include updatedMedia(sm) {
            padding-top: 6px;
            padding-bottom: 32px;
        }
    }
    .m-block-form-title-title{
        margin-bottom: 40px;
        @include media(md) {
            margin-bottom: 32px;
        }
        @include media(sm) {
            margin-bottom: 20px;
        }
    }
</style>
